<template>
       
    <div class="navigation-tree-preview">
               
        <div v-if="!items || items.length === 0" class="empty-state">       </div>
               
        <ul v-else class="nav-tree-list">
                       
            <li v-for="item in items" :key="item.Id" class="nav-tree-item">
                                               
                <div class="nav-item-content">
                                        <span class="nav-title">{{ getTitle(item) }}</span>                    
                    <b-badge v-if="!item.IsActive" variant="light-danger" class="badge-sm" pill>                              </b-badge>                
                </div>

                                                <navigation-tree-preview v-if="item.ChildNavigations && item.ChildNavigations.length" :items="item.ChildNavigations" :language="language" />            
            </li>
        </ul>
           
    </div>
</template>

<script>
import { BBadge } from "bootstrap-vue";

export default {
    name: "NavigationTreePreview",
    components: {
        BBadge,
    },
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        language: {
            type: String,
            default: "tr",
        },
    },
    methods: {
        getTitle(item) {
            const translation = item.Translations?.find((t) => t.LanguageCode === this.language);
            return translation?.Title || item.NavigationKey || "-";
        },
    },
};
</script>

<style lang="scss" scoped>
.navigation-tree-preview {
    max-height: 280px;
    overflow-y: auto;
    padding: 4px;

    .empty-state {
        text-align: center;
        padding: 2rem;
        font-size: 0.9rem;
        color: #6e6b7b;
        @at-root .dark-layout & {
            color: #b4b7bd;
        }
    }

    .nav-tree-list {
        list-style: none;
        padding-left: 0;
        margin: 0;
    }

    ::v-deep .nav-tree-item {
        margin-bottom: 4px;
    }

    ::v-deep .nav-item-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.5rem 0.75rem;
        border-radius: 6px;
        transition: background-color 0.2s;

        .nav-title {
            font-weight: 500;
            font-size: 0.875rem;
        }

        .badge-sm {
            font-size: 0.7rem;
            padding: 0.2em 0.5em;
            font-weight: 600;
        }
    }

    .nav-tree-item .navigation-tree-preview {
        margin-top: 4px;
        padding-left: 20px;
        position: relative;

        &::before {
            content: "";
            position: absolute;
            left: 8px;
            top: 0;
            bottom: 0;
            width: 1px;
        }
    }

    .nav-item-content {
        background: #f8f9fa;
        border: 1px solid #f0f0f0;
        &:hover {
            background: #f1f3f5;
        }
    }
    .nav-tree-item .navigation-tree-preview::before {
        background: #e0e0e0;
    }

    @at-root .dark-layout {
        .nav-item-content {
            background: #161d31;
            border: 1px solid #3b4253;
            &:hover {
                background: #1e2537;
            }
        }
        .nav-tree-item .navigation-tree-preview::before {
            background: #3b4253;
        }
    }
}
</style>
